import React, { useState } from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slider,
} from "@mui/material";
import Cropper from "react-easy-crop";
import fullImage from "../../Components/Assets/images/fullImage.png";
import pass1 from "../../Components/Assets/images/passport1.png";
import pass2 from "../../Components/Assets/images/passport2.png";

const demoImages = {
  image1: pass2,
  image2: pass1,
  image3: fullImage,
};

const aspectRatio = {
  image1: 3 / 4,
  image2: 3 / 4,
  image3: 2 / 3,
};

const ThreeImageUploader = ({ value = {}, onChange, validationErrors }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [currentKey, setCurrentKey] = useState("");
  const [croppedPixels, setCroppedPixels] = useState(null);

  const onSelectImage = (e, key) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setCurrentKey(key);
      setOpen(true);
    };
    reader.readAsDataURL(file);
  };

  const onCropComplete = (_, pixels) => {
    setCroppedPixels(pixels);
  };

  const getCroppedBase64 = async (src, pixels) => {
    const image = new Image();
    image.src = src;
    await new Promise((r) => (image.onload = r));

    const canvas = document.createElement("canvas");
    canvas.width = pixels.width;
    canvas.height = pixels.height;

    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      image,
      pixels.x,
      pixels.y,
      pixels.width,
      pixels.height,
      0,
      0,
      pixels.width,
      pixels.height
    );

    return canvas.toDataURL("image/jpeg", 0.9);
  };

  const saveCrop = async () => {
    const base64 = await getCroppedBase64(imageSrc, croppedPixels);

    onChange({
      ...value,
      [currentKey]: base64,
    });

    setOpen(false);
  };

  return (
    <>
      <Grid container spacing={3} mt={4}>
        {[1, 2, 3].map((n) => {
          const key = `image${n}`;
          return (
            <Grid item xs={12} md={4} key={key}>
              <div
                style={{
                  background: "#fff",
                  padding: 10,
                  border: validationErrors?.[key]
                    ? "1px dashed red"
                    : "1px dashed #ccc",
                  borderRadius: 8,
                  textAlign: "center",
                }}
              >
                <img
                  src={value[key] || demoImages[key]}
                  alt={key}
                  style={{
                    width: "100%",
                    height: 300,
                    objectFit: "contain", // ✅ full image dikhegi
                    borderRadius: 6,
                    marginBottom: 8,
                    background: "#f5f5f5", // optional: empty area ke liye
                  }}
                />

                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  size="small"
                  color={validationErrors?.[key] ? "error" : "primary"}
                >
                  Upload Image {n}
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    onChange={(e) => onSelectImage(e, key)}
                  />
                </Button>

                {validationErrors?.[key] && (
                  <div
                    style={{
                      color: "red",
                      fontSize: 12,
                      marginTop: 4,
                      textAlign: "left",
                    }}
                  >
                    {validationErrors[key]}
                  </div>
                )}
              </div>
            </Grid>
          );
        })}
      </Grid>

      {/* Crop Dialog */}
      <Dialog open={open} maxWidth="sm" fullWidth>
        <DialogTitle>Crop Image</DialogTitle>

        <DialogContent>
          <div style={{ position: "relative", height: 300 }}>
            <Cropper
              image={imageSrc}
              crop={crop}
              zoom={zoom}
              aspect={aspectRatio[currentKey]}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          <Slider
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            onChange={(_, z) => setZoom(z)}
            sx={{ mt: 2 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={saveCrop}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ThreeImageUploader;
